import { Keuzehulp } from '../keuzehulpen'

const keelamandelen: Keuzehulp = {
  title: 'Keelamandelen',
  basePath: '/keelamandelen',
  documentTitle: 'Keelamandelen',
  routes: [
    {
      path: '',
      routeId: 'P7-001',
      nextRouteId: 'P7-002',
      type: 'intro',
      title: 'Voordat u begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/wel-of-niet-weghalen-van-keel-amandelen-bij-keel-ontstekingen',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die u nodig heeft om de keuzehulp in te vullen',
        },
        {
          title: '5 tot 10 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustig plekje',
          description: 'Zodat u zich zonder afleiding kunt concentreren',
        },
        {
          title: 'Download uw gegevens',
          description: 'Aan het einde kunt u uw antwoorden bekijken en printen',
        },
      ],
    },
    {
      path: '/stap-1',
      routeId: 'P7-002',
      nextRouteId: 'P7-003',
      type: 'chapter',
      title: 'U heeft vaak en veel last van een keelontsteking.',
      subtitle: 'Stap 1',
      description: `
        <div>
          <p style="margin-bottom: 0;">Op de volgende pagina leggen we uit:</p>
          <ul>
            <li>wat zijn keel-amandelen</li>
            <li>wat is een keel-ontsteking</li>
            <li>welke klachten u daarbij kunt hebben</li>
          </ul>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/ka-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/uw-klachten',
      routeId: 'P7-003',
      nextRouteId: 'P7-004',
      type: 'explanation',
      title: 'Uw klachten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat zijn keel-amandelen?</h2>
          <p style="margin-top: 0;">De keel-amandelen zijn 2 bobbels links en rechts achterin de keel.<br />
          Ze helpen om virussen en bacteri&euml;n te bestrijden.</p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat is een ontsteking van de keel-amandelen?</h2>
          <p style="margin-top: 0;">Als er veel virussen en bacteri&euml;n zijn, moeten de keel-amandelen hard werken.<br />
          Ze raken dan ontstoken en worden groter (plaatje).</p>

          <div class="img-wrapper" class="mb-2">
            <img src="${process.env.PUBLIC_URL}/img/kam-stap-1.png" alt="keelamandelen" />
          </div>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wat merkt u bij een ontsteking van de keel-amandelen?</h2>
          <ul>
            <li>U heeft keelpijn en slikken en praten gaan moeilijk.</li>
            <li>U kunt zich ziek voelen en koorts hebben.</li>
            <li>De klieren in de hals kunnen dik worden en pijn doen.</li>
            <li>U kunt uit uw mond stinken.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-1/wat-zijn-de-mogelijkheden',
      routeId: 'P7-004',
      nextRouteId: 'P7-005',
      type: 'explanation',
      title: 'Wat zijn de mogelijkheden?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <ul>
            <li>afwachten</li>
            <li>een operatie om de keel-amandelen weg te halen</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-2',
      routeId: 'P7-005',
      nextRouteId: 'P7-006',
      type: 'chapter',
      title: 'Afwachten',
      subtitle: 'Stap 2',
      description: 'Afwachten betekent dat u leert leven met de ontstekingen van keel-amandelen.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/ka-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/afwachten',
      routeId: 'P7-006',
      nextRouteId: 'P7-007',
      type: 'explanation',
      title: 'Afwachten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p class="mb-3">Afwachten betekent dat u leert leven met de ontstekingen van keel-amandelen.<br />
          U kunt medicijnen nemen tegen de pijn. Antibiotica hebben meestal geen zin.<br />
          De ontsteking gaat meestal binnen 1 week vanzelf over.</p>

          <h2>Wat kan ik verwachten?</h2>
          <p class="mb-3">U heeft iets meer kans om vaker een keel-ontsteking te krijgen als u kiest voor afwachten.<br />
          Ook kunnen de ontstekingen ernstiger zijn.</p>

          <h2>Wat kan er misgaan?</h2>
          <p class="mb-3">Er kan meestal niks misgaan bij afwachten. Heel soms kan de keel-ontsteking ernstig worden.</p>

          <h2>Voordelen</h2>
          <ul class="mb-3">
            <li>U heeft niet de ongemakken van een operatie.</li>
            <li>U heeft geen ongemakken van de narcose.</li>
            <li>U heeft geen kans dat er iets misgaat bij een operatie.</li>
            <li>U kunt later toch nog kiezen voor een operatie.</li>
            <li>U hoeft meestal niet naar het ziekenhuis.</li>
          </ul>

          <h2>Nadelen</h2>
          <p class="mb-3">U heeft iets meer kans om vaker een keel-ontsteking te krijgen.<br />
          Ook kunnen de ontstekingen erger zijn dan na een operatie.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3',
      routeId: 'P7-007',
      nextRouteId: 'P7-008',
      type: 'chapter',
      title: 'Operatie om de keel-amandelen weg te halen',
      subtitle: 'Stap 3',
      description: 'Bij deze operatie haalt de kno-arts uw amandelen via uw mond weg.',
      image: {
        src: `${process.env.PUBLIC_URL}/img/ka-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/operatie-1',
      routeId: 'P7-008',
      nextRouteId: 'P7-009',
      type: 'explanation',
      title: 'Operatie om de keel-amandelen weg te halen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Een paar dagen voor de operatie krijgt u een afspraak bij de verdovingsarts of verpleegkundige.<br />
          Voor de operatie wordt u in slaap gebracht en voelt u niks meer.<br />
          Dit noemen we narcose.</p>

          <p class="mb-3">Tijdens de operatie haalt de kno-arts de keel-amandelen weg via uw mond.<br />
          De operatie zelf duurt ongeveer 10 tot 30 minuten.</p>

          <h2>Na de operatie</h2>
          <p>Na de operatie heeft u pijn in de keel en moeite met slikken.<br />
          Ook kunt u pijn in de oren voelen.<br />
          U krijgt medicijnen tegen de pijn.<br />
          Ook kan er wat bloed uit de keel komen.</p>

          <p>U kan vaak dezelfde dag of de volgende dag naar huis.<br />
          Zorg dat iemand u thuis brengt.</p>

          <p class="mb-3">Er is een kleine kans dat u klachten krijgt door de narcose.<br />
          Bijvoorbeeld: misselijkheid, overgeven, of koorts.</p>

          <h2>Weer thuis</h2>
          <p>Na de operatie heeft u veel keelpijn. Dit wordt pas na 4 tot 5 dagen minder.<br />
          De keel kan nog 2 weken lang pijn doen. Hierdoor kunt u ook 2 weken lang problemen hebben met eten.<br />
          Pijnstillers, koude dranken en waterijsjes helpen tegen de pijn.</p>

          <p class="mb-3">Veel mensen hebben de eerste dagen na de operatie een verandering van smaak.<br />
          Dit gaat bijna altijd vanzelf over, maar kan maanden duren.</p>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-3/operatie-2',
      routeId: 'P7-009',
      nextRouteId: 'P7-010',
      type: 'explanation',
      title: 'Operatie om de keel-amandelen weg te halen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2>Wat kan ik verwachten?</h2>
          <p>U kunt na een operatie nog wel keel-ontstekingen krijgen.<br />
          Dit komt dan door een ontsteking van andere delen van de keel.</p>

          <p>Veel mensen die vaak keel-ontstekingen hadden, hebben na de operatie minder ontstekingen.<br />
          Ook zijn de ontstekingen vaak minder erg dan als u kiest voor afwachten.</p>

          <p>Hoe meer ontstekingen u voor de operatie had, hoe meer voordeel u van de operatie kunt verwachten.</p>

          <p class="mb-3">U krijgt geen slechtere weerstand nadat de keel-amandelen zijn weggehaald.</p>

          <h2>Wat kan er misgaan?</h2>
          <p>Er is een kans dat de wond weer gaat bloeden.</p>
          <ul style="margin-left: 25px;">
            <li>3 van de 100 mensen krijgt dit na een operatie.</li>
          </ul>
          <p class="mb-3">U spuugt hierdoor opeens helder rood bloed uit. Dit gebeurt meestal binnen 12 uur na de operatie, maar het kan ook nog tot 2 weken na de operatie.<br />
          U moet dan naar het ziekenhuis.<br />
          Vaak moet u opnieuw geopereerd worden om de bloeding te stoppen.</p>

          <div class="img-wrapper mb-3">
            <img src="${process.env.PUBLIC_URL}/img/kam-stats-1.png" alt="keelamandelen operatie statistieken" />
          </div>

          <h2>Voordelen</h2>
          <p style="margin-bottom: 0">Een operatie zorgt er waarschijnlijk voor dat:</p>
          <ul class="mb-3">
            <li>u minder keel-ontstekingen krijgt</li>
            <li>de keel-ontstekingen minder erg zijn</li>
          </ul>

          <h2>Nadelen</h2>
          <ul class="mb-3">
            <li>U kunt klachten van de narcose krijgen. Bijvoorbeeld misselijkheid, overgeven, of koorts.</li>
            <li>U heeft ongemak van een operatie.</li>
            <li>Er is een kans dat er iets misgaat tijdens of na de operatie.</li>
            <li>U kunt tot 2 weken na de operatie last van de keel hebben.</li>
            <li>Er is een kans dat uw smaak verandert en dat dit maanden duurt.</li>
          </ul>
        </div>
      `,
      button: 'Volgende',
    },
    {
      path: '/stap-4',
      routeId: 'P7-010',
      nextRouteId: 'P7-011',
      type: 'chapter',
      title: 'Vergelijk de mogelijkheden',
      subtitle: 'Stap 4',
      description: 'Wat is voor u belangrijk?',
      image: {
        src: `${process.env.PUBLIC_URL}/img/ka-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vergelijk-de-mogelijkheden',
      routeId: 'P7-011',
      nextRouteId: 'P7-012',
      type: 'explanation',
      title: 'Vergelijk de mogelijkheden',
      description: `
        <table class="table-layout-fixed">
          <thead>
            <tr>
              <th></th>
              <th>Afwachten</th>
              <th>Operatie: keel-amandelen weghalen</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Wat betekent het?</th>
              <td>Geen operatie.</td>
              <td>Een operatie waarbij u narcose krijgt.<br>De kno-arts haalt de keel-amandelen weg via de mond.<br>Na de operatie kan de keel 2 weken lang pijn doen.</td>
            </tr>
            <tr>
              <th>Wat kan ik verwachten?</th>
              <td>U heeft iets meer kans op keel-ontstekingen.<br>De ontstekingen kunnen ernstiger zijn.</td>
              <td>Minder keel-ontstekingen.<br>De ontstekingen zijn vaak minder erg.</td>
            </tr>
            <tr>
              <th>Wat kan er misgaan?</th>
              <td>Meestal niks.<br>Heel soms kan de keel-ontsteking ernstig worden.</td>
              <td>De wond kan weer gaan bloeden (3 van de 100 mensen).<br>Soms tijdelijk verandering van stem of smaak.</td>
            </tr>
            <tr>
              <th>Voordelen</th>
              <td>Niet de ongemakken van een operatie.<br>Geen kans op klachten van de narcose.<br>Niet het risico dat er iets misgaat bij een operatie.<br>U kunt later toch nog kiezen voor een operatie.<br>Meestal niet naar het ziekenhuis.</td>
              <td>Iets minder kans om een keel-ontsteking te krijgen.<br>De keel-onststekingen kunnen minder erg zijn.</td>
            </tr>
            <tr>
              <th>Nadelen</th>
              <td>Iets meer kans om een keel-ontsteking te krijgen.<br>De ontstekingen kunnen erger zijn.</td>
              <td>Kans op klachten door de narcose.<br>Ongemakken van een operatie.<br>Kans dat er iets misgaat tijdens of na de operatie.<br>U kunt tot 2 weken na de operatie last van de keel hebben.<br>Kans dat de smaakverandering maanden kan duren.</td>
            </tr>
          </tbody>
        </table>`,
      align: 'left',
      titleAlign: 'center',
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P7-012',
      nextRouteId: 'P7-013',
      type: 'question',
      title: 'Wat verwacht u van de behandeling?',
      questions: [
        {
          placeholder: 'Bijvoorbeeld: Minder vaak keelpijn. Minder last van keelpijn.',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-2',
      routeId: 'P7-013',
      nextRouteId: 'P7-014',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Als ik een keel-ontsteking heb, doe ik de normale dingen die ik altijd doe.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-3',
      routeId: 'P7-014',
      nextRouteId: 'P7-015',
      type: 'likertScale',
      subtitle: 'Stelling',
      title:
        'Ik wil dat de kans op een keel-ontsteking zo klein mogelijk is, ik wil een operatie wel proberen.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-4',
      routeId: 'P7-015',
      nextRouteId: 'P7-016',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik heb problemen met een operatie onder narcose.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-5',
      routeId: 'P7-016',
      nextRouteId: 'P7-017',
      type: 'likertScale',
      subtitle: 'Stelling',
      title:
        'Ik kan toch nog een keel-ontsteking krijgen na een operatie; ik vind het de moeite niet waard.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-6',
      routeId: 'P7-017',
      nextRouteId: 'P7-018',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Ik wil niet het ongemak van een operatie.',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-7',
      routeId: 'P7-018',
      nextRouteId: 'P7-019',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: "Ik maak me zorgen om de risico's van een operatie.",
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-8',
      routeId: 'P7-019',
      nextRouteId: 'P7-020',
      subtitle: 'Maak een keuze',
      title: 'Wat wilt u?',
      type: 'uniqueQuestion',
      layout: 'vertical',
      answers: [{ title: 'Afwachten' }, { title: 'Een operatie' }],
    },
    {
      path: '/stap-4/vraag-9',
      routeId: 'P7-020',
      nextRouteId: 'P7-021',
      type: 'question',
      title: 'Waarom wilt u dit het liefst?',
      questions: [
        {
          placeholder: 'Schrijf hier op waarom',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/stap-4/vraag-10',
      routeId: 'P7-021',
      nextRouteId: 'P7-022',
      type: 'likertScale',
      subtitle: 'Stelling',
      title: 'Hoe zeker bent u van wat u wilt?',
      answers: [
        { title: 'Heel onzeker' },
        { title: 'Onzeker' },
        { title: 'Weet ik niet' },
        { title: 'Zeker' },
        { title: 'Heel zeker' },
      ],
      button: 'Door naar uw antwoorden',
    },
    {
      path: '/print-overview',
      routeId: 'P7-022',
      nextRouteId: 'end',
      type: 'end',
    },
  ],
}

export default keelamandelen
